<template>
	<v-app>
		<v-main><router-view></router-view></v-main>
		<v-footer>
			<m-footer></m-footer>
		</v-footer>
	</v-app>
</template>

<script>
import mFooter from './components/footer.vue';

export default {
	name: 'App',
	components: {
		mFooter
	},
	data: () => ({
		//
	})
};
</script>
